var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import OutlinedLoading from 'acud-icon/lib/icons/OutlinedLoading';
import classNames from 'classnames';
import { ConfigContext } from '../config-provider';
import useMergedState from '../_util/hooks/useMergedState';
const Switch = React.forwardRef((_a, ref) => {
    var { prefixCls: customizePrefixCls, className, checked, defaultChecked, disabled, loading, loadingIcon: customLoadingIcon, checkedChildren, unCheckedChildren, onClick, onChange } = _a, restProps = __rest(_a, ["prefixCls", "className", "checked", "defaultChecked", "disabled", "loading", "loadingIcon", "checkedChildren", "unCheckedChildren", "onClick", "onChange"]);
    const [innerChecked, setInnerChecked] = useMergedState(false, {
        value: checked,
        defaultValue: defaultChecked,
    });
    const { getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('switch', customizePrefixCls);
    const loadingIcon = loading
        && (customLoadingIcon || (<OutlinedLoading className={`${prefixCls}-loading-icon`} animation="spin"/>));
    function triggerChange(newChecked, event) {
        let mergedChecked = innerChecked;
        if (!disabled) {
            mergedChecked = newChecked;
            setInnerChecked(mergedChecked);
            onChange === null || onChange === void 0 ? void 0 : onChange(mergedChecked, event);
        }
        return mergedChecked;
    }
    function onInternalClick(e) {
        const ret = triggerChange(!innerChecked, e);
        onClick === null || onClick === void 0 ? void 0 : onClick(ret, e);
    }
    const switchClassName = classNames(prefixCls, className, {
        [`${prefixCls}-checked`]: innerChecked,
        [`${prefixCls}-loading`]: loading,
        [`${prefixCls}-disabled`]: disabled,
    });
    return (<button {...restProps} type="button" role="switch" aria-checked={innerChecked} disabled={disabled} className={switchClassName} ref={ref} onClick={onInternalClick}>
                {loadingIcon}
                <span className={`${prefixCls}-inner`}>
                    {innerChecked ? checkedChildren : unCheckedChildren}
                </span>
            </button>);
});
Switch.displayName = 'Switch';
Switch.__ACUD_SWITCH = true;
export default Switch;
